import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

const SpecDropdownAddOptionModal = ({
    open,
    specTitle,
    onClose,
    onConfirm,
    busy = false,
}) => {
    const inputRef = useRef(null);
    const [value, setValue] = useState('');

    useEffect(() => {
        if (open) {
            setValue('');
            const t = window.setTimeout(() => inputRef.current?.focus(), 50);
            return () => window.clearTimeout(t);
        }
        return undefined;
    }, [open]);

    if (!open) {
        return null;
    }

    const runConfirm = async () => {
        if (busy) {
            return;
        }
        await onConfirm(value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        await runConfirm();
    };

    const handleInputKeyDown = (e) => {
        if (e.key !== 'Enter' || e.shiftKey || e.nativeEvent?.isComposing) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        runConfirm();
    };

    return createPortal(
        <div
            className="modal-backdrop spec-dropdown-add-modal-backdrop"
            onClick={onClose}
            role="presentation"
        >
            <div
                className="modal-content spec-dropdown-add-modal"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-labelledby="spec-dropdown-add-modal-title"
            >
                <div className="modal-header">
                    <h3 id="spec-dropdown-add-modal-title">드롭다운 옵션 추가</h3>
                    <button type="button" className="modal-close" onClick={onClose} disabled={busy} aria-label="닫기">×</button>
                </div>
                <p className="spec-dropdown-add-modal-spec">
                    사양 항목: <strong>{specTitle}</strong>
                </p>
                <form onSubmit={handleSubmit} onKeyDown={(e) => e.stopPropagation()}>
                    <label className="field-label" htmlFor="spec-dropdown-add-input">옵션 값</label>
                    <input
                        id="spec-dropdown-add-input"
                        ref={inputRef}
                        type="text"
                        className="field-input"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        onKeyDown={handleInputKeyDown}
                        placeholder="목록에 추가할 값"
                        disabled={busy}
                        autoComplete="off"
                    />
                    <div className="spec-dropdown-add-modal-actions">
                        <button type="button" className="button button-cancel" onClick={onClose} disabled={busy}>취소</button>
                        <button
                            type="button"
                            className="button"
                            disabled={busy || !value.trim()}
                            onClick={runConfirm}
                        >
                            {busy ? '처리중...' : '확인'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    , document.body);
};

export default SpecDropdownAddOptionModal;
